import {connect} from 'react-redux';
import {toggleBottomBar} from '../../../redux/modules/split-pane/actions';
import {ISplitPaneState} from '../../../redux/modules/split-pane/reducer';
import {SessionEditorSplitPane as Container, ISessionEditorSplitPaneProps} from './split-pane-ui';

interface IStore {
  splitPane: ISplitPaneState;
}

const mapStateToProps = (state: IStore) => ({
  bottomBarHidden: state.splitPane.bottomBarHidden,
});

const mapDispatchToProps = {
  toggleBottomBar,
};

export const SessionEditorSplitPane = connect<ISessionEditorSplitPaneProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(Container);
